// extracted by mini-css-extract-plugin
export default {"container":"ScrollToTopButton_container--dmW","background":"ScrollToTopButton_background--YWK","arrowIcon":"ScrollToTopButton_arrowIcon--kI1"};